import { useAccount } from '@/domain/hooks/useAccount'
import { SuspenseQueryWith } from '@/utils/types'
import { type UseQueryResult, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { L1Balances, l1BalancesQueryOptions } from './query'

export type UseL1BalancesResult = SuspenseQueryWith<{
  balances: L1Balances
}>

export type UseL1BalancesQueryResult = Omit<UseQueryResult<L1Balances>, 'data'> & {
  balances: L1Balances
}

export function useL1Balances({ refetchInterval }: { refetchInterval?: number } = {}): UseL1BalancesResult {
  const account = useAccount()

  const response = useSuspenseQuery({
    ...l1BalancesQueryOptions({
      account,
    }),
    refetchInterval: refetchInterval ?? undefined,
  })

  return {
    ...response,
    balances: response.data,
  }
}

export function useL1BalancesQuery({ refetchInterval }: { refetchInterval?: number } = {}): UseL1BalancesQueryResult {
  const account = useAccount()

  const response = useQuery({
    ...l1BalancesQueryOptions({
      account,
    }),
    refetchInterval: refetchInterval ?? undefined,
  })

  return {
    ...response,
    balances: response.data ?? [],
  }
}
